import React, { useContext, useState, useEffect } from "react";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import "./index.css";
import "./chart.css";
import "./step.css";
import Nav from "./layouts/nav";
import ScrollToTop from "./ScrollToTop";
import { ThemeContext } from "../context/ThemeContext";
import OTimbrado from "./pages/opciones/Otimbrado";
import Ocostos from "./pages/opciones/Ocostos";
import Oseguros from "./pages/opciones/Oseguros";
import Oformasdepago from "./pages/opciones/Oformasdepago";
import Osucursal from "./pages/opciones/Osucursal";
import Omoneda from "./pages/opciones/Omoneda";
import FacturaContado from "./pages/FacturaContado";
import Depositado from "./pages/facturascontado/Depositado";
import Nodepositado from "./pages/facturascontado/Nodepositado";
import FacturaCredito from "./pages/FacturaCredito";
import Reporte from "./pages/Reportes";
import Opuntodeventa from "./pages/opciones/Opuntodeventa";
import Clientes from "./pages/facturacion/Clientes";
import Facturas from "./pages/facturacion/Facturas";
import Listadeventas from "./pages/facturacion/Listadeventas.js";
import FichaCliente from "./pages/facturacion/Fichas/FichaCliente";
import FichaFactura from "./pages/facturacion/Fichas/FichaFactura";
import Vencimiento from "./pages/facturascredito/Vencimientos";
import Cobranzas from "./pages/facturascredito/Cobranza";
import Generarfactura from "./pages/Generarfactura.js";
import AppLogout from "./AppLogout";
import Proveedores from "./pages/compras/Proveedores";
import Compras from "./pages/compras/Compras";
import Listadecompras from "./pages/compras/Listadecompras";
import Reportecompras from "./pages/compras/Reportecompras";
import GenerarCompra from "./pages/compras/GenerarCompra";
import Presupuestos from "./pages/Presupuestos/Presupuestos"
import FichaPresupuesto from "./pages/Presupuestos/fichapresupuesto.js"
import FichaFacturaCompra from "./pages/compras/FichaFacturaCompra.js";
import Admin from "./pages/admin/admin";
import NuevoPresupuesto from "./pages/Presupuestos/NuevoPresupuesto"
import Error404 from "./pages/Error404";
import { getAdminCredentials, getAdminById } from "../Api/AdminApi";
import Spinner from "./components/Spinner";

const Markup = () => {
  const [user, setDATAUSER] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const assignValue = async () => {
      try {
        const resultUser = await getAdminCredentials();
        const datauser = await getAdminById(resultUser.IdUsuario);
     
        setDATAUSER(datauser[0] || {});
      } catch (error) {
        console.error("Error fetching user:", error);
        setDATAUSER({});
      } finally {
        setLoading(false);
      }
    };
    assignValue();
  }, []);

  const allRoutes = [
    // ──────── OPCIONES ────────
    { url: "Opcionesdetimbrado",    component: <AppLogout><OTimbrado /></AppLogout>,        permission: "opciones_timbrado" },
    { url: "Opcionesdecosto",       component: <AppLogout><Ocostos /></AppLogout>,          permission: "opciones_servicioproducto" },
    { url: "Opcionesformadepago",   component: <AppLogout><Oformasdepago /></AppLogout>,    permission: "opciones_formasdepago" },
    { url: "Opcionesdemoneda",      component: <AppLogout><Omoneda /></AppLogout>,          permission: null },
    { url: "Opcionesdesucursal",    component: <AppLogout><Osucursal /></AppLogout>,        permission: "opciones_sucursal" },
    { url: "Opcionesseguros",       component: <AppLogout><Oseguros /></AppLogout>,         permission: "opciones_seguros" },
    { url: "Opcionesodv",           component: <AppLogout><Opuntodeventa /></AppLogout>,    permission: "opciones_puntosdeventa" },

    // ──────── VENTAS ────────
    { url: "FacturaContado",        component: <AppLogout><FacturaContado /></AppLogout>,   permission: "ventas_facturascontado" },
    { url: "depositado",            component: <AppLogout><Depositado /></AppLogout>,       permission: "ventas_facturascontado" },
    { url: "nodepositado",          component: <AppLogout><Nodepositado /></AppLogout>,     permission: "ventas_facturascontado" },
    { url: "FacturaCredito",        component: <AppLogout><FacturaCredito /></AppLogout>,   permission: "ventas_facturascredito" },
    { url: "Reporte",               component: <AppLogout><Reporte /></AppLogout>,          permission: "ventas_reportes" },
    { url: "Clientes",              component: <AppLogout><Clientes /></AppLogout>,         permission: "ventas_clientes" },
    { url: "Facturas",              component: <AppLogout><Facturas /></AppLogout>,         permission: "ventas_facturas" },
    { url: "Detalles",              component: <AppLogout><Listadeventas /></AppLogout>,    permission: "ventas_detalles" },
    { url: "FichaCliente/:id",      component: <AppLogout><FichaCliente /></AppLogout>,      permission: "ventas_clientes" },
    { url: "FichaFactura/:id",      component: <AppLogout><FichaFactura /></AppLogout>,      permission: "ventas_montos" },
    { url: "cobranza",              component: <AppLogout><Cobranzas /></AppLogout>,        permission: "ventas_facturascredito" },
    { url: "vencimientos",          component: <AppLogout><Vencimiento /></AppLogout>,      permission: "ventas_facturascredito" },
    { url: "generarfactura",        component: <AppLogout><Generarfactura /></AppLogout>,   permission: "ventas_facturas" },

    // ──────── COMPRAS ────────
    { url: "proveedores",           component: <AppLogout><Proveedores /></AppLogout>,      permission: "compras_proveedores" },
    { url: "compras",               component: <AppLogout><Compras /></AppLogout>,          permission: "compras_compras" },
    { url: "listadecompras",        component: <AppLogout><Listadecompras /></AppLogout>,   permission: "compras_listacompras" },
    { url: "reportecompras",        component: <AppLogout><Reportecompras /></AppLogout>,   permission: "compras_reportes" },
    { url: "generarcompra",         component: <AppLogout><GenerarCompra /></AppLogout>,    permission: "compras_compras" },
    { url: "FichaFacturaCompra/:id",component: <AppLogout><FichaFacturaCompra /></AppLogout>,permission: "compras_compras" },
      // ────────Presupuesto ────────
    { url: "presupuestos",           component: <AppLogout><Presupuestos /></AppLogout>,      permission: "ventas_clientes" },
    { url: "nuevopresupuesto",       component: <AppLogout><NuevoPresupuesto /></AppLogout>,      permission: "ventas_clientes" },
     { url: "fichapresupuesto/:id",       component: <AppLogout><FichaPresupuesto/></AppLogout>,      permission: "ventas_clientes" },

    // ──────── ADMIN ────────
    {
      url: "admin",
      component: <AppLogout><Admin /></AppLogout>,
      permission: user && (user.IdTipoUsuario === "0" || user.IdTipoUsuario === "1") ? "admin" : null,
    },

    // ──────── ERROR 404 ────────
    { url: "Error404", component: <AppLogout><Error404 /></AppLogout>, permission: "ALL" },
  ];

  /** Esperar a que cargue el usuario antes de renderizar las rutas */
 if (loading || !user) {
  return <Spinner />;
}

  // Filtra rutas según permisos del usuario
  const accessibleRoutes = allRoutes.filter(route => {
    if (route.permission === "ALL") return true;              // públicas
    if (!route.permission) return false;                      // sin permiso definido => fuera
    if (route.permission === "admin")
      return user.IdTipoUsuario === "0" || user.IdTipoUsuario === "1";
    return user[route.permission] === "true";
  });

  const isFacturasAccessible = accessibleRoutes.some(route => route.url === "Facturas");

  return (
    <>
      <Routes>
        <Route element={<Layout7 />}>
          {accessibleRoutes.map((data, i) => (
            <Route key={i} path={`/${data.url}`} element={data.component} />
          ))}
          <Route
            path="*"
            element={
              isFacturasAccessible
                ? <Navigate to="/Facturas" replace />
                : <Navigate to="/Error404" replace />
            }
          />
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function Layout7() {
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);

  return (
    <div id="main-wrapper" className="show">
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height + 20 }}
      >
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Markup;